'use client'

import cn from 'classnames'
import _Image, { ImageProps } from 'next/image'
import { FC, ReactElement, useState } from 'react'

// 拡張したProps型
type ExtendedImageProps = Omit<ImageProps, 'src'> & {
  duration?: boolean
  lazy?: boolean
  src: string
}

export const Image: FC<ExtendedImageProps> = ({
  className,
  lazy = true,
  onLoad,
  quality = 85,
  src,
  alt = '',
  ...props
}): ReactElement => {
  const [stateReady, setStateReady] = useState(!lazy)

  const onLoadCallback = (e: any) => {
    setStateReady(true)
    typeof onLoad === 'function' && onLoad(e)
  }

  return (
    <div
      className={cn(
        '',
        {
          'absolute top-0 left-0 h-full w-full': props.fill,
          'bg-primary': !stateReady,
          'bg-transparent transition duration-500 delay-1000': stateReady,
        },
        className,
      )}
    >
      <_Image
        src={src}
        alt={alt}
        onLoad={onLoadCallback}
        priority={!lazy}
        quality={quality}
        loading={lazy ? 'lazy' : 'eager'}
        className={cn('object-cover', {
          '!opacity-100': stateReady,
          'opacity-0': lazy && !stateReady,
          'transition-opacity duration-500 delay-300': lazy,
        })}
        {...props}
      />
    </div>
  )
}
